import { zodResolver } from "@hookform/resolvers/zod"
import { BaseCustomerForm } from "modules/customers/components/List/Upsert/BaseCustomerForm"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { Route as BackofficeCustomersListRoute } from "routes/_base/_auth/backoffice/organizations/$id/companies/$companyId/customers/list"
import {
  BackofficeGetCustomerResponseDataSchema,
  UpsertBackofficeCustomerBodySchema,
  UpsertCustomerBodySchema,
} from "schema"
import { z } from "zod"

type TypeUpsertBackofficeCustomerBody = z.input<typeof UpsertBackofficeCustomerBodySchema>
type TypeUpsertCustomerBody = z.infer<typeof UpsertCustomerBodySchema>

type BackofficeCustomerFormProps = {
  customer?: Omit<z.infer<typeof BackofficeGetCustomerResponseDataSchema>, "client">
  onSubmit: (data: TypeUpsertBackofficeCustomerBody) => void
  submitCopy: string
}

export const BackofficeCustomerForm = ({
  customer,
  onSubmit,
  submitCopy,
}: BackofficeCustomerFormProps) => {
  const { companyId } = BackofficeCustomersListRoute.useParams()
  const form = useForm<TypeUpsertCustomerBody>({
    resolver: zodResolver(UpsertCustomerBodySchema),
  })

  useEffect(() => {
    if (customer) {
      form.reset({
        ...customer,
        firstName: customer.firstName ?? (customer.lastName ? null : customer.name),
      })
    }
  }, [customer, form])

  const handleOnSubmit = (data: TypeUpsertCustomerBody) => {
    onSubmit({ ...data, metadata: data.metadata as string, companyId })
  }

  return <BaseCustomerForm form={form} onSubmit={handleOnSubmit} submitCopy={submitCopy} />
}
